/** Today as YYYY-MM-DD in the user's local timezone */
export function todayISO(): string {
  return toISODate(new Date())
}

/** Formats a Date as YYYY-MM-DD in local time */
export function toISODate(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** Parses a YYYY-MM-DD (or ISO timestamp) string as a local date */
export function parseDate(value: string): Date {
  const [y, m, d] = value.slice(0, 10).split('-').map(Number)
  return new Date(y, m - 1, d)
}

const DAY_MS = 24 * 60 * 60 * 1000

/** Whole days between two dates (b - a), ignoring DST shifts */
export function daysBetween(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / DAY_MS)
}
